import { useMemo } from 'react';

import dynamic from 'next/dynamic';

import { RoomsVariationBarItem as Props } from './props';
import {
  ActiveItemMark,
  Container,
  PriceWrapper,
  RoomName,
  SubLabel,
} from './style';

const OriginalPrice = dynamic(
  () => import('@components/ui/price/OriginalPrice')
);

const RoomsVariationBarItem = ({
  price,
  roomName,
  isActive,
  currency,
  onItemClicked,
  selectedDepatureFlight,
  selectedDepatureTransfer,
  selectedReturnFlight,
  selectedReturnTransfer,
  adultCount,
  childCount,
}: Props) => {
  const totalTransferPrice = useMemo(() => {
    return (
      (selectedDepatureTransfer?.trySalePrice || 0) +
      (selectedReturnTransfer?.trySalePrice || 0)
    );
  }, [
    selectedDepatureTransfer,
    selectedReturnTransfer,
    adultCount,
    childCount,
  ]);
  return (
    <Container isActive={isActive} onClick={onItemClicked}>
      <RoomName isActive={isActive} title={roomName}>
        {roomName}
      </RoomName>

      {price ? (
        <PriceWrapper isActive={isActive}>
          <OriginalPrice
            price={
              price +
              (selectedDepatureFlight?.orginalItem?.totalPrice || 0) +
              (selectedReturnFlight?.orginalItem?.totalPrice || 0) +
              totalTransferPrice
            }
            currency={currency}
            noLine
          />

          <SubLabel isActive={isActive}>‘den başlayan fiyatlarla</SubLabel>
        </PriceWrapper>
      ) : null}

      {isActive ? <ActiveItemMark /> : null}
    </Container>
  );
};

export default RoomsVariationBarItem;
